import React from "react";

import { StyledMainBox } from "../../components/commonComponents/StyledComponents/styled";

import { useParams } from "react-router-dom";

import AccessControl from "../../components/commonComponents/Hoc/AccessControl";

import { fetchCampaign, ANALYTICS_UNAVAILABLE_CAMPAIGN_NOT_FOUND } from "../../api_calls/campaignRequests";

import { useSelector } from "react-redux";

import { checkUserRole } from "../../api_calls/userManagement";

import { fetchReportTabsConfigForPublishedReport } from "../../api_calls/ReportSettings";

import AnalyticsDashboard from "./Reports/AnalyticsDashboard";

import CampaignAnalyticsEmptyState from "./CampaignAnalyticsEmptyState";

/**
 * Retailer / Cyreen campaign analytics page.
 *
 * Load path (see loadCampaignAnalyticsDependencies inside fetchCampaign):
 * campaign detail → campaign stores (scoped by bottom-nav retailer) → if any stores,
 * catalogs + report settings → seed embedded_* filters; otherwise empty-state only.
 */
const CampaignAnalytics = () => {
  const userRole = checkUserRole();
  const campaignDetails = useSelector((state) => state.userSelections);
  const { id } = useParams();

  const hasCampaignDetail = typeof campaignDetails.campaign_detail !== "undefined";
  const storesScopeEmpty = campaignDetails.analytics_campaign_stores_scope_empty === true;
  const unavailableReason = campaignDetails.analytics_report_unavailable_reason;
  const hasBrandFilters = typeof campaignDetails.brand_filters !== "undefined";

  const reportTabsConfig =
    hasCampaignDetail && hasBrandFilters
      ? fetchReportTabsConfigForPublishedReport(userRole.user_role)
      : [];

  const showEmptyState =
    storesScopeEmpty === true &&
    (hasCampaignDetail === true || unavailableReason === ANALYTICS_UNAVAILABLE_CAMPAIGN_NOT_FOUND);

  React.useEffect(() => {
    fetchCampaign(id, "all", userRole.user_role, "analytics");
  }, []);

  return (
    <StyledMainBox
      component="main"
      sx={{
        padding: "10px 13px",
        ...(showEmptyState === true
          ? {
              flex: 1,
              alignSelf: "stretch",
              minWidth: 0,
              minHeight: "100vh",
              display: "flex",
              flexDirection: "column",
            }
          : {}),
      }}
    >
      {showEmptyState === true && (
        <CampaignAnalyticsEmptyState reason={unavailableReason} />
      )}

      {hasCampaignDetail === true &&
        storesScopeEmpty !== true &&
        hasBrandFilters === true &&
        reportTabsConfig.length !== 0 && (
          <AnalyticsDashboard
            reportSettingArr={reportTabsConfig}
            viewMode={userRole.user_role}
            preview={false}
          />
        )}
    </StyledMainBox>
  );
};

export default AccessControl(CampaignAnalytics, [
  "campaign_reports_performance_can_view",
  "campaign_reports_impression_can_view",
], [], ["campaigns_section", "campaign_list"]);
